export const SHOW_NOTIFICATION = "SHOW_NOTIFICATION";
export const HIDE_NOTIFICATION = "HIDE_NOTIFICATION";

export const showNotification = (notification) => ({
  type: SHOW_NOTIFICATION,
  payload: notification,
});

export const hideNotification = () => ({
  type: HIDE_NOTIFICATION,
});
